// extracted by mini-css-extract-plugin
export default {"waveLink":"WaveLink_waveLink__pSCQH","empty":"WaveLink_empty__U7AEH"};